import Grid from '@mui/material/Grid';
import Model3DScene from '../Components3D/Model3DScene'
import useMediaQuery from '@mui/material/useMediaQuery';


function Model3DLayout({ children, ...props }){
	const mobile = useMediaQuery('(max-width:1000px)');

  return(
    <Grid
      container
      style={{
        display:'flex',
        alignItems:"center",
        justifyContent:"center"
      }}
    >
      <Grid
        style={{
          maxWidth:mobile ? '100vw': '50vw',
          display:'flex',
          alignItems:"center",
          flexDirection:mobile ?'column':"row"
        }}
      >
        <Grid
          item
          style={{
            display:"flex",
            justifyContent:"center",
            alignItems:"center", 
          }}
        >
          {props.title}
        </Grid>
        <Grid
          item
        >
          <Model3DScene>{props.model3D}</Model3DScene>
        </Grid>
      </Grid>

    </Grid>
  )
}

export default Model3DLayout;